export const CourierUmbrellaName: {
  [key: string]: string;
} = {
  apg: 'APG',
  aramex: 'Aramex',
  'australia-post': 'Australia Post eParcel',
  'mypost-business': 'Australia Post MyPost Business',
  'australia-post-on-demand': 'Australia Post On Demand',
  'canada-post': 'Canada Post',
  'couriers-please': 'CouriersPlease',
  dhl: 'DHL',
  'dhl-ecommerce': 'DHL eCommerce',
  dpex: 'DPEX',
  fastway: 'Fastway',
  fedex: 'FedEx',
  'fedex-cross-border': 'FedEx Cross Border',
  janio: 'Janio',
  lasership: 'Lasership',
  'on-trac': 'OnTrac',
  'royal-mail': 'Royal Mail',
  seko: 'Seko',
  sendle: 'Sendle',
  skypostal: 'Skypostal',
  'star-track': 'StarTrack',
  tnt: 'TNT',
  ups: 'UPS®️',
  passport: 'Passport',
};

export enum CourierLogo {
  Fedex = 'fedex',
  FedexCrossBorder = 'fedex-cross-border',
  Ups = 'ups',
  AustraliaPost = 'australia-post',
  AustraliaPostOnDemand = 'australia-post-on-demand',
  MyPost = 'mypost-business',
  Dhl = 'dhl',
  DhlEcommerce = 'dhl-ecommerce',
  Sendle = 'sendle',
  StarTrack = 'star-track',
  CanadaPost = 'canada-post',
  RoyalMail = 'royal-mail',
  Passport = 'passport',
  Skypostal = 'skypostal',
  Apg = 'apg',
}

export enum CourierAccountState {
  Active = 'active',
  Pending = 'pending',
}

export enum CourierAuthState {
  Verified = 'verified',
  Failed = 'failed',
  PartiallyVerified = 'partially_verified',
}
